import { trackAmplitudeEvent } from '../CustomEvents'

const PAYMENT_TYPE_LABELS = {
  card: 'new card',
  paypal: 'paypal',
  ideal: 'ideal',
  bank: 'bank transfer',
  gift_card: 'gift card'
}

export function paymentTypeLabel (value) {
  if (value?.startsWith('saved_card_')) return 'saved card'
  return PAYMENT_TYPE_LABELS[value] || value
}

export function trackCheckoutPaymentSubmit (paymentType) {
  trackAmplitudeEvent('Checkout Submit Payment clicked', { 'payment type': paymentType })
}
